import classNames from 'classnames';
import * as React from 'react';

import './BetaMark.css';

interface BetaMarkProps {
    cls?: string;
}

export class BetaMark extends React.PureComponent<BetaMarkProps> {
    render() {
        return (
            <span className={classNames('beta-mark', this.props.cls)}>β</span>
        );
    }
}
